import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Plus, Trash2, Clock } from "lucide-react";

export const DAY_LABELS = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];

export default function CoachAvailabilityCard() {
  const { user, refresh } = useAuth();
  const [rows, setRows] = useState(user.availability || []);
  const [draft, setDraft] = useState({ day: 0, start: "09:00", end: "12:00" });

  const add = () => {
    if (draft.start >= draft.end) return toast.error("L'heure de fin doit être après le début");
    setRows([...rows, { ...draft, day: Number(draft.day) }].sort((a, b) => a.day - b.day || a.start.localeCompare(b.start)));
  };
  const remove = (i) => setRows(rows.filter((_, k) => k !== i));

  const save = async () => {
    try {
      await api.put("/coaches/me", { availability: rows });
      refresh && refresh();
      toast.success("Disponibilités enregistrées");
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };

  return (
    <div className="mt-6 sc-card" data-testid="coach-availability-card">
      <h2 className="text-lg font-bold text-slate-900 flex items-center gap-2"><Clock className="w-5 h-5 text-orange-500" /> Mes disponibilités</h2>
      <p className="text-sm text-slate-600 mt-1">Indiquez vos jours et heures d'entraînement : les clients réservent au bon moment.</p>
      <div className="mt-3 flex flex-wrap gap-2 items-center">
        <select data-testid="avail-day" className="border border-slate-200 rounded-xl p-2 text-sm" value={draft.day} onChange={(e) => setDraft({ ...draft, day: e.target.value })}>
          {DAY_LABELS.map((d, i) => <option key={i} value={i}>{d}</option>)}
        </select>
        <input data-testid="avail-start" type="time" className="border border-slate-200 rounded-xl p-2 text-sm" value={draft.start} onChange={(e) => setDraft({ ...draft, start: e.target.value })} />
        <span className="text-slate-400 text-sm">→</span>
        <input data-testid="avail-end" type="time" className="border border-slate-200 rounded-xl p-2 text-sm" value={draft.end} onChange={(e) => setDraft({ ...draft, end: e.target.value })} />
        <button data-testid="avail-add" onClick={add} className="sc-btn sc-btn-outline text-sm"><Plus className="w-4 h-4" /> Ajouter</button>
      </div>
      <div className="mt-3 flex flex-wrap gap-2" data-testid="avail-list">
        {rows.map((r, i) => (
          <span key={i} data-testid={`avail-row-${i}`} className="inline-flex items-center gap-2 text-xs px-3 py-1.5 rounded-full bg-orange-500/10 text-orange-800 border border-orange-500/20">
            <b>{DAY_LABELS[r.day]}</b> {r.start} – {r.end}
            <button data-testid={`avail-remove-${i}`} onClick={() => remove(i)} className="text-rose-600" aria-label="Supprimer"><Trash2 className="w-3 h-3" /></button>
          </span>
        ))}
        {rows.length === 0 && <span className="text-sm text-slate-500">Aucune disponibilité renseignée.</span>}
      </div>
      <div className="mt-3 flex justify-end"><button data-testid="avail-save" onClick={save} className="sc-btn sc-btn-emerald">Enregistrer</button></div>
    </div>
  );
}
